import React, { useState, useEffect } from 'react';
import { Container, Nav, Navbar, Button, Row, Col, Card, Carousel, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import home from '../Images/home3.webp';
import c1 from '../Images/c1.jpg';
import c2 from '../Images/c2.jpg';
import c3 from '../Images/c3.jpeg';
import c4 from '../Images/c4.jpeg';
import c5 from '../Images/c5.jpg';
import c6 from '../Images/c6.jpeg';
import './Home.css';
import Header from './Header';

export default function Home() {

    const [show, setShow] = useState(false);
    const [selectedImg, setSelectedImg] = useState(null);

    const handleShow = (img) => {
        setSelectedImg(img);
        setShow(true);
    };

    const handleClose = () => setShow(false);

    // 🔥 Scroll Animations – Intersection Observer
    useEffect(() => {
        const revealElements = document.querySelectorAll(".reveal");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("active");
                    }
                });
            },
            { threshold: 0.2 }
        );

        revealElements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <div>
            {/* Navbar */}
            <Header />

            {/* Hero Banner */}
            <section className="banner-section d-flex align-items-center">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6} className="text-section reveal fade-up">
                            <h1 className="fw-bold display-5">
                                We Stitch Designs that <br />
                                <span className="text-danger" >Fit You Perfectly</span>
                            </h1>

                            <p className="lead mt-3" style={{ maxWidth: '450px' }}>
                                Experience elegance and comfort with our handcrafted tailoring services.
                                Each outfit is made with care, style, and precision.
                            </p>

                            <Button
                                variant="danger"
                                size="lg"
                                as={Link}
                                to="/collection"
                                className="rounded-pill mt-3 px-4"
                            >
                                Explore Collection
                            </Button>
                        </Col>

                        <Col md={6} className="text-center reveal slide-in-right">
                            <div className="banner-img-wrapper">
                                <img
                                    src={home}
                                    alt="Tailoring Banner"
                                    className="banner-img"
                                />
                            </div>
                        </Col>

                    </Row>
                </Container>
            </section>

            {/* Collections Section */}
            <section className="collections-section py-5 bg-dark">
                <Container fluid className="px-md-5 px-3">
                    <h2 className="text-center fw-bold mb-4 text-light reveal fade-up">
                        Our Latest Collections
                    </h2>

                    <Carousel indicators={false}>
                        <Carousel.Item>
                            <Row className="justify-content-center g-3">
                                {[{ img: c1, title: "Evening Gown", text: "Elegant handcrafted gown for special occasions." },
                                { img: c2, title: "Graceful Saree Collection", text: "Traditional yet trendy sarees that define elegance." },
                                { img: c3, title: "Designer Jacket Saree", text: "Fusion of modern jacket style with a classic saree look." }
                                ].map((item, index) => (
                                    <Col key={index} md={3} sm={6} xs={10} className="reveal fade-up">
                                        <Card className="collection-card shadow-sm border-0 bg-light">
                                            <Card.Img
                                                variant="top"
                                                src={item.img}
                                                onClick={() => handleShow(item.img)}
                                                className="cursor-pointer"
                                                style={{ borderRadius: "8px" }}
                                            />
                                            <Card.Body className="text-center">
                                                <Card.Title>{item.title}</Card.Title>
                                                <Card.Text>{item.text}</Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Carousel.Item>

                        <Carousel.Item>
                            <Row className="justify-content-center g-3">
                                {[{ img: c4, title: "Elegant Pink Saree", text: "Soft and stylish, perfect for festive and formal wear." },
                                { img: c5, title: "Bridal Collection", text: "Finely tailored bridal wear for your special day." },
                                { img: c6, title: "Traditional Saree Look", text: "Classic South Indian style with intricate gold detailing." }
                                ].map((item, index) => (
                                    <Col key={index} md={3} sm={6} xs={10} className="reveal fade-up">
                                        <Card className="collection-card shadow-sm border-0 bg-light">
                                            <Card.Img
                                                variant="top"
                                                src={item.img}
                                                onClick={() => handleShow(item.img)}
                                                className="cursor-pointer"
                                                style={{ borderRadius: "8px" }}
                                            />
                                            <Card.Body className="text-center">
                                                <Card.Title>{item.title}</Card.Title>
                                                <Card.Text>{item.text}</Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Carousel.Item>
                    </Carousel>

                    <Modal show={show} onHide={handleClose} centered size="md">
                        <Modal.Body className="text-center bg-dark">
                            <img
                                src={selectedImg}
                                alt="collection-preview"
                                className="img-fluid rounded"
                                style={{ maxHeight: "400px" }}
                            />
                        </Modal.Body>
                    </Modal>
                </Container>
            </section>

            {/* Footer */}
            <footer className="bg-light text-dark pt-4 pb-2 mt-5 reveal fade-up">
                <Container>
                    <Row className="text-center text-md-start">

                        {/* Column 1 */}
                        <Col md={4} sm={6} className="mb-3">
                            <h5 className="fw-bold text-danger">AKUL CREATIONS STICKES AND DESIGNING</h5>
                            <p className="text-muted">
                                Your one-stop destination for custom-stitched designs —
                                blending tradition and modern fashion with perfection.
                            </p>
                        </Col>

                        {/* Column 2 */}
                        <Col md={5} sm={6} className="mb-3">
                            <h6 className="fw-bold">Location</h6>

                            <p className="text-muted mb-1">
                                #222,12th Main,3rd Cross.Saraswathipuram,Mysore 570009</p>
                            <p className="text-muted">📞 +91 8951088742 | 7899788742</p>
                        </Col>

                        {/* Column 3 */}
                        <Col md={3} sm={6} className="mb-3">
                            <h6 className="fw-bold">Follow Us</h6>
                            <div>
                                <a href="#" className="text-dark me-3 fs-4"><i className="bi bi-facebook"></i></a>
                                <a href="#" className="text-dark me-3 fs-4"><i className="bi bi-instagram"></i></a>
                                <a href="#" className="text-dark me-3 fs-4"><i className="bi bi-twitter"></i></a>
                                <a href="#" className="text-dark fs-4"><i className="bi bi-youtube"></i></a>
                            </div>
                        </Col>
                    </Row>

                    <hr />

                    <Row>
                        <Col className="text-center">
                            <p className="mb-0 text-muted">
                                © {new Date().getFullYear()} AKUL CREATIONS STICKES AND DESIGNING
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </div>
    );
}
